import $ from 'jquery';
import { formatMoney } from '@shopify/theme-currency';
import generateHTML from './generateHTML';
import openCart from './openCart';
import { status } from './plusMinusQuantity';

const updateCartView = (cart) => {
  if (status.debouncing) { return; }

  $(document).trigger('cartWillUpdate', cart);

  $('[data-cart-count]').attr('data-cart-count', cart.item_count).text(cart.item_count);
  $('[data-cart-total]').text(formatMoney(cart.total_price, theme.moneyFormat));
  $('[data-cart-products]').empty();

  if (cart.item_count === 0) {
    $('[data-cart]').addClass('SliderCart--empty');
  } else {
    $('[data-cart]').removeClass('SliderCart--empty');
    generateHTML(cart);
  }

  openCart();

  window.cart = cart;
  $(document).trigger('cartDidUpdate', cart);
};

export default function(cart) {
  if (cart) {
    return updateCartView(cart);
  }
  
  return $.getJSON('/cart.js', (json) => {
    updateCartView(json);
  });
}